const notification = (
  <path
    d="M10 12V12.6C10 13.2365 9.78929 13.847 9.41421 14.2971C9.03914 14.7471 8.53043 15 8 15C7.46957 15 6.96086 14.7471 6.58579 14.2971C6.21071 13.847 6 13.2365 6 12.6V12M13.8482 10.9337C12.9735 9.90476 12.3559 9.38095 12.3559 6.5442C12.3559 3.94643 10.9757 3.02092 9.83976 2.57143C9.68886 2.51185 9.54682 2.375 9.50084 2.22604C9.30158 1.57423 8.74296 1 8.00041 1C7.25785 1 6.6989 1.57455 6.50168 2.2267C6.45569 2.37729 6.31366 2.51185 6.16276 2.57143C5.02543 3.02158 3.6466 3.94381 3.6466 6.5442C3.6449 9.38095 3.02735 9.90476 2.15264 10.9337C1.79022 11.36 2.10768 12 2.74157 12H13.2626C13.8931 12 14.2086 11.358 13.8482 10.9337Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
export default notification;
